import { useMutation, useQueryClient } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import type { BlockUserInterface } from "types/blockUser";
import {
    createBlockUserRequest,
    deleteBlockUserRequest,
    getBlockUserRequest,
} from "lib/api/blockUser";

export const createBlockUser = (data: HashMap<unknown>) =>
    parseResponse<BlockUserInterface>(createBlockUserRequest(data));

export const fetchBlockUser = (blockedUserId: string) =>
    parseResponse<BlockUserInterface>(getBlockUserRequest(blockedUserId));

export const deleteBlockUser = (blockedUserId: string) =>
    parseResponse<BlockUserInterface>(deleteBlockUserRequest(blockedUserId));

export const blockUserKeys = {
    all: ["blockUser"] as const,
    detail: (id: string) => [...blockUserKeys.all, "detail", id] as const,
};

export const useCreateBlockUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data: HashMap<unknown>) => createBlockUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: blockUserKeys.all });
        },
    });
};

export const useDeleteBlockUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => deleteBlockUser(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: blockUserKeys.all });
        },
    });
};
